export function isPastTime(timeString: string): boolean {
    const [time, modifier] = timeString.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier === 'PM' && hours < 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;

    const eventDateTime = new Date();
    eventDateTime.setHours(hours, minutes, 0, 0);

    const now = new Date();

    return eventDateTime < now;
}

export function isTodayOrInThePast(date: Date): boolean {

    const inputDate = new Date(date);
    const today = new Date();
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return inputDate.getTime() <= today.getTime();
}

export function generateSuggestions(value: string): string[] {
    const num = Number(value);
    if (Number.isNaN(num)) return [];

    const units = ['Hour', 'Day', 'Week', 'Month', 'Year'];
    return units.map(unit => `${num} ${unit}${num !== 1 ? 's' : ''}`);
}

export function parseApiDate(value: Date | string | null | undefined): Date | null {
    if (!value) {
        return null;
    }

    if (value instanceof Date) {
        return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    if (typeof value === 'string') {
        const dateMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|T)/);
        if (dateMatch) {
            const [, year, month, day] = dateMatch;
            return new Date(Number(year), Number(month) - 1, Number(day));
        }
    }

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function formatDateOnlyForApi(value: Date | string | null | undefined): string | null {
    const parsedDate = parseApiDate(value);
    if (!parsedDate) {
        return null;
    }

    const year = parsedDate.getFullYear();
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = parsedDate.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export function toNativeDate(value: unknown): Date | null {
    if (!value) {
        return null;
    }

    if (value instanceof Date) {
        return new Date(value);
    }

    if (
        typeof value === 'object' &&
        'toDate' in value &&
        typeof (value as { toDate?: unknown }).toDate === 'function'
    ) {
        const date = (value as { toDate: () => unknown }).toDate();
        return date instanceof Date
            ? new Date(date)
            : new Date(date as string | number);
    }

    return new Date(value as string | number);
}

/**
 * Flattens a BaseRespone's errors (array or keyed object) into a single
 * display string for toasts, falling back to the response message.
 */
export function getResponseErrorMessage(response: { errors?: unknown; message?: string | null } | null | undefined): string {
    if (!response) {
        return '';
    }

    const errors = response.errors;

    if (Array.isArray(errors) && errors.length > 0) {
        return errors.map(String).join('\n');
    }

    if (errors && typeof errors === 'object') {
        const messages = Object.values(errors).flat().filter(Boolean).map(String);
        if (messages.length > 0) {
            return messages.join('\n');
        }
    }

    return response.message ? response.message : '';
}
